import { Button, Tooltip, Zoom } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {
  getClassroomIdByUserId,
  getInfosAccountRestricted,
} from '@webapps/business';
import {
  useAuth,
  useQuery,
  useStrophe,
} from '@webapps/reactjs-tech-components';
import { withStyles } from '@material-ui/core/styles';
import { useStyles } from '@webapps/styles';
import {businessMenu, schoolMenu, studentMenu, ROUTES_PATH, schoolMenuFree, businessMenuFree, cfaMenu} from 'config/constants';
import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import StarIcon from 'components/Icons/Star';
import { useHistory } from 'react-router-dom';
import Modal from 'components/Modal';


import theme from './theme';
import zIndex from '@material-ui/core/styles/zIndex';

const LightTooltip = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: primaryColor,
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    fontWeight: 600,
  },
  tooltipPlacementRight: {
    margin: '0 -8px',
  }
}))(Tooltip);

const LightTooltip2 = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: "#F50057",
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    fontWeight: 600,
  },
  tooltipPlacementRight: {
    margin: '0 -8px',
  }
}))(Tooltip);


const {
  colors: { itemActive, primaryColor },
  images: { miniLogoLinkpick },
} = theme;

const Sidebar = () => {
  const [menu, setMenu] = useState([]);
  const [hasClass, setHasClass] = useState(false);
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { pathname } = useLocation();
  const { userAlias, idUser, logout, profile, isPremium } = useAuth();
  const { disconnect } = useStrophe();
  const [openModal, setOpenModal] = useState(false);
  const { push } = useHistory();

  const handleLogOutOnClick = () => {
    disconnect();
    logout();
  };

  const { data: infos = [], isFetching, isLoading } = useQuery(getInfosAccountRestricted, {
    key: ['profilInfo2', idUser],
    variables: { id: idUser },
    });
    
    const { data: classroomId } = useQuery(getClassroomIdByUserId, {
      key: 'classroomIdMinimizePlanning',
      variables: { id: idUser },
      enabled: !!idUser
    })

  useEffect(() => {
    if(profile === "INDIVIDUAL"){
      
      setHasClass(classroomId !== undefined)
    }
  }, [infos])

  // SIDE BAR MENU ACCORDING TO ACCOUNT TYPE & SUBSCRIPTION TYPE
  {/* Front end restrictions */}
  useEffect(() => {
    if (!isFetching && !isLoading) {
      if (profile === 'SCHOOL' && (isPremium)) {
        setMenu(schoolMenu);
      } else if (profile === 'BUSINESS' && (isPremium)) {
        setMenu(businessMenu);
      } else if (profile === 'INDIVIDUAL') {
        setMenu(studentMenu);
      } else if (profile === 'SCHOOL' && (isPremium === false)) { // DONT CHANGE ISPREMIUM CAN BE NULL
        setMenu(schoolMenuFree);
      } else if (profile === 'BUSINESS' && (isPremium === false)) { // DONT CHANGE ISPREMIUM CAN BE NULL
        setMenu(businessMenuFree);
      } else if (profile === 'CFA') {
        setMenu(cfaMenu);
      }
    }
  }, [pathname, infos, isPremium]);

  return (
    <div className={classes.sidebar}>
      <div className={classes.divTitle}>
        <Link to={
          profile === 'INDIVIDUAL'
            ? ROUTES_PATH.STUDENT_DASHBOARD
            : profile === 'SCHOOL'
              ? ROUTES_PATH.SCHOOL_DASHBOARD
              : profile === 'BUSINESS' 
                ? ROUTES_PATH.BUSINESS_DASHBOARD
                : ROUTES_PATH.CFA_DASHBOARD
        }>
          <img alt="Linkpick" className={classes.logo} src={miniLogoLinkpick} />
        </Link>
      </div>
      <div className={classes.navbar}>
        {menu
        .filter((item) => !item.exclude)
        .filter((item) => !(!hasClass && item.excludeIfClassroomEmpty))
        .filter((item) => !item.restriction || item.restriction.includes(idUser))
        .map(({ icon: Icon, link, name, altLinks, disabled }) => (
          <LightTooltip title={name} placement='right' enterDelay={0}  >
            <NavLink
              key={link}
              className={!disabled ? classes.item : classes.itemDisabled}
              exact
              onClick={() => {disabled && setOpenModal(true)}}
              replace={pathname === link}
              to={!disabled && link}
              isActive={() => link === pathname || altLinks?.includes(pathname)}
            >
              <div
                className={css({
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                })}
              >
                <div className={classes.itemIcon}>
                  {disabled && 
                    <StarIcon className={classes.star} />
                  }
                  {Icon &&
                    <Icon className={classes.icon} />
                  }
                </div>
              </div>
            </NavLink>
          </LightTooltip>
        ))}
      </div>
      <div style={{
        overflowY: 'auto',
        width: '100%', marginTop: 'auto', marginBottom: '10px'
      }}>
        <LightTooltip2 title='Se déconnecter' placement='right' enterDelay={0}>
          <NavLink
            className={cx(classes.item, classes.logoutHover)}
            onClick={handleLogOutOnClick}
            to={pathname}
            isActive={() => false}
          >
            <div
              className={css({
                display: 'flex',
                width: '70%',
                alignItems: 'center',
                justifyContent: 'center'
              })}
            >
              <div className={classes.itemIcon}>
                <ExitToAppIcon className={classes.icon} />
              </div>
            </div>
          </NavLink>
        </LightTooltip2>
      </div>
        <Modal
          open={openModal}
          onCancel={() => setOpenModal(false)}
          title="Vous n'avez pas accès à cette fonctionnalité"
        >
          <div>
            <div className={classes.modalContentText}>Pour profiter pleinement de cette fonctionnalité, veuillez souscrire à l'offre adaptée <div/>
            <div className={classes.modalContentButtons}>
              <Button
                color="primary"
                onClick={() => {setOpenModal(false); profile === "SCHOOL" ? push(`${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`) : push(`${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`) }}
                variant="contained"
              >
                Voir les offres
              </Button>
            </div>
            </div>
          </div>  
        </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  sidebar: {
    backgroundColor: '#152652',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 1000,
    '@media only screen and (max-width:768px)': { display: 'none' }
  },
  divTitle: {
    background: primaryColor,
    minHeight: '87px',
    marginBottom: spacing(2),
    width: '68px',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0 0 50px 50px',
    '@media only screen and (max-width:1600px)': {width: '68px'},
  },
  avatar: {
    height: 100,
    width: 100,
    marginTop: spacing(3),
  },
  navbar: {
    marginTop: spacing(1.5),
    overflowY: 'auto',
    width: '100%',
  },
  item: {
    display: 'flex',
    width: '100%',
    height: 33,
    marginTop: spacing(0.5),
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    textDecoration: 'none',
    color: '#5A6DA1',
    fontWeight: 400,
    itemIcon: {
      color: 'white',
    },
    '&:hover, &.active': {
      fontWeight: 600,
      color: '#ffffff',
      boxShadow: `inset 5px 0px 0px 0px #0060F9`,
    },
  },
  logoutHover: {
    '&:hover, &.active': {
      fontWeight: 600,
      color: '#ffffff',
      boxShadow: `inset 5px 0px 0px 0px #F50057`,
    },
  },
  itemDisabled: {
    display: 'flex',
    cursor: 'not-allowed',
    width: '100%',
    height: 45,
    position: 'relative',
    marginTop: spacing(0.5),
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: '#5A6DA1',
    fontWeight: 400,
    itemIcon: {
      color: 'white'
    },
  },
  star: {
    position: 'absolute',
    width: '12px',
    top: '3px',
    zIndex: 100,
    right: '17px',
  },
  modalContentText: {
    textAlign: 'center',
    fontWeight: 400,
    color: '#5D75A8',
    marginTop: spacing(1),
  },
  modalContentButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: spacing(2),
  },
  itemIcon: {
   display: 'flex',
   alignItems: 'center',
  },
  btnParams: {
    marginTop: 'auto',
  },
  btnLogoutContainer: {
    marginTop: 'auto',
  },
  logo: { height: 40, marginLeft: '6px' },
  icon: { 
    fontSize: '24px',
  },

});

export default Sidebar;
